import {mainSheet} from './models/StyleSheetManager'
import StyleSheet from './sheet'

export const __PRIVATE__ = {
  StyleSheet,
  mainSheet,
}
